import React, { useState, useContext } from 'react';
import { createPortal } from 'react-dom';
import classNames from 'classnames';
import { SwapItem } from '@thd-olt-component-react/swap-item';
import { Button, Col, Row } from '@thd-olt-component-react/core-ui';
import { QueryContext, QueryProvider } from '@thd-nucleus/data-sources';
import { string, bool, arrayOf, shape } from 'prop-types';
import { ProductSetContext } from '../../context/ProductSetContext';
import { RemoveBtnDrawer } from '../RemoveDrawer/RemoveDrawer';
import { RadioButtons } from '../RadioButtons/RadioButtons';
import './cta-section.scss';

export const CallToActionSection = ({
  itemId,
  productGroup,
  showCTA,
  products
}) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const { swapGroup, isMobile } = useContext(ProductSetContext);
  const { defaultVariables } = useContext(QueryContext) || {};

  const handleSwap = (swappedItem) => {
    swapGroup([swappedItem.product], productGroup);
  };

  if (!showCTA) {
    return null;
  }

  const newDefaultVariables = {
    ...(typeof defaultVariables?.current?.isBrandPricingPolicyCompliant === 'boolean' && {
      isBrandPricingPolicyCompliant: defaultVariables.current.isBrandPricingPolicyCompliant
    })
  };

  return (
    <>
      {isMobile && products.length > 1
        && (
          <RadioButtons
            products={products}
            productGroup={productGroup}
          />
        )}
      <Row className={classNames('cta-section', { 'cta-section__desktop': !isMobile })} data-testid="cta-section">
        <QueryProvider
          cacheKey="productSet-swap-item"
          defaultVariables={newDefaultVariables}
        >
          <Col xs="6" nopadding>
            <div className="cta-section__item--first">
              <SwapItem
                itemId={itemId}
                className="cta-section__swap-button"
                onSwap={handleSwap}
                isDark={false}
                hideIcon
                btnContent="Swap"
                closeOnSwap
                isSmall
              />
            </div>
          </Col>
        </QueryProvider>
        <Col xs="6" className="cta-section__item" nopadding>
          <div className="cta-section__item--second">
            <Button
              className="cta-section__remove-button"
              outline
              onClick={() => setIsDrawerOpen(true)}
              small
            >
              Remove
            </Button>
            {isDrawerOpen
              && createPortal(
                <RemoveBtnDrawer
                  closeDrawer={() => setIsDrawerOpen(false)}
                  itemId={itemId}
                  isDrawerOpen={isDrawerOpen}
                  productGroup={productGroup}
                  products={products}
                />, document.body
              )}
          </div>
        </Col>
      </Row>
    </>
  );
};

CallToActionSection.propTypes = {
  itemId: string.isRequired,
  productGroup: string.isRequired,
  showCTA: bool.isRequired,
  products: arrayOf(shape({})).isRequired
};
